import i18n from '@vue-storefront/core/i18n';

export const filterWithValueNotFound = () => ({
  type: 'warning',
  timeToLive: 10000,
  message: i18n.t('There are no products for given filters. Please look for similar equipment'),
  action1: { label: i18n.t('OK') }
});
